import { BaseInputFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import React from "react";

const UsernameFilter = ({ label = "l.searchFilter.email", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter label={label} fieldName={"email"} {...others} />;
};

export default UsernameFilter;
